<template>
  <DbSelectCustom
    v-model="model"
    class="db-sorting"
    :options="options"
    :inputAttrs="{
      title: $t('Sort results'),
    }"
  >
    <span class="db-visually-hidden">{{ $t('Sort results') }}</span>
    <template v-slot:current="{ label }">
      <span class="db-visually-hidden">{{ label }}</span>
    </template>
    <template v-slot:fieldicon>
      <IconDbSorting
        width="20"
        height="20"
      />
    </template>
  </DbSelectCustom>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { SelectHTMLAttributes } from 'vue'
import type { Options } from '@/types/components/combobox'

const props = defineProps<{
  /** Tableau d'options */
  options: Options
  /** binds /w `v-model` directive */
  modelValue: number | string
  /** InputHTMLAttributes /w `id` omitted */
  inputAttrs?: Omit<SelectHTMLAttributes, 'id'>
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', modelValue: number | string): void
}>()

/** Computed to handle v-model directive */
const model = computed({
  get() {
    return props.modelValue
  },
  set(value: number | string) {
    emit('update:modelValue', value)
  },
})
</script>

<style>
@import '@/assets/styles/components/forms/_radio.css';
@import '@/assets/styles/components/_sorting.css';
</style>
